module.exports = __webpack_public_path__ + "img/3.231e0aa5.jpg";